import React from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import { getFeatureSwitchByKey, getLocalSessionData } from "../../../utils/Authentication/handleUserSession";
import { BONUS_PAGE_COUNT, DISCOUNT_PRICE, featureSwitchName, HWINC_DEVICEUSAGE_TYPES, LOCALSESSIONDATAKEYS } from "../../../constants/AppConstants";
import currencies from "../../../constants/CurrencyTypes";
import './paymentSummary.css';
import { Is_HWInclusive_Signup, fetchHwIncDeviceUsageType, formatNumberOnLocale, getPlanTranslation } from "../../../constants/AppMethod";
import { Link } from "react-router-dom";
import { WebCustomerRoutePaths, WebHardwareInclusiveRoutePath } from "../../../constants/Routes";

const PaymentSummary = (props) => {
    const { t } = useTranslation(["translation"]);
    const { planDetails, goTo } = props;
    const {planName, price, currency, discountPlanIds, HWPlans = null, discount} = planDetails || {};
    const DEVICE_MODEL = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
    const DEVICEID = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID)
    const SERIALNUMBER = getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER)
    const NETWORKSTATUS = getLocalSessionData(LOCALSESSIONDATAKEYS.NETWORK_STATUS)
    const isHWInclusive_Signup = Is_HWInclusive_Signup();
    const isBonusPagesFeatureEnabled= ( getFeatureSwitchByKey(featureSwitchName.BONUS_PAGES) && discount?.length ) ? true : false;
    const subscriptionKind = fetchHwIncDeviceUsageType()
    /**
     * `isRefurbished` - Derived from `fetchHwIncDeviceUsageType()`.
     * Returns TRUE if the device usage type is NOT a new printer bundle.
     * WARNING: This can be misleading — it also returns TRUE for non-HWInc
     * devices since REFURBISHED.NAME is the default fallback in fetchHwIncDeviceUsageType().
     * Avoid using this for strict refurbished checks.
     * Use it along with the check (isHWInclusive_Signup && isRefurbished)
     */
    const isRefurbished = subscriptionKind === HWINC_DEVICEUSAGE_TYPES.REFURBISHED.NAME;
    /**
     * `isDeviceRefurbished` - Derived from `isRefurbishedUsageType()`.
     * Returns TRUE ONLY if the deviceUsageType explicitly matches REFURBISHED.ID
     * from the session data (WEB_SELECTED_PLAN).
     * Use this for strict/accurate refurbished device checks.
     */

    const isRefurbishedUsageType = () => {
         const webSelectedPlanRaw = getLocalSessionData(LOCALSESSIONDATAKEYS.WEB_SELECTED_PLAN);
        const webSelectedPlan = (webSelectedPlanRaw) ? JSON.parse(webSelectedPlanRaw) : null;
        return Number(webSelectedPlan?.HWPlans?.deviceUsageType) === HWINC_DEVICEUSAGE_TYPES.REFURBISHED.ID;
    }

    const isDeviceRefurbished = isRefurbishedUsageType();

    const handleChangePlanLink = (goTo) => {
        let goToURL;
            goToURL = `${goTo}`
            return goToURL;
    }
    return(
        <div className="summary-outer-wrapper">
            <Container className="payment-summary-wrapper">
                <div className="payment-summary-content-wrapper">
                    <div className="top-section">
                        <div className="left-content">
                            <h5>{t("PAYMENT_SUMMARY.TITLE")}</h5>
                            <div className="plan-details">
                                <p className="plan-name">
                                    {t("PAYMENT_SUMMARY.PLAN_NAME", {plan_name: getPlanTranslation(planName)})}
                                </p>
                                <p className="printer-model-type">
                                    {
                                        t("PAYMENT_SUMMARY.DEVICE_MODEL", {device_model: DEVICE_MODEL})
                                    }
                                </p>
                            </div>
                        </div>
                        <div className="right-content">
                            <p className="change-plan-link">
                                { (goTo === WebCustomerRoutePaths.SELECT_PLAN || goTo === WebHardwareInclusiveRoutePath.SELECT_PRINTER)  ? 
                                    ( <a href={handleChangePlanLink(goTo)} id="change-plan">{t("PAYMENT_SUMMARY.CHANGE_PLAN_LINK")}</a> ) : ( 
                                        <Link to={{
                                            pathname: goTo,
                                            state : {
                                                    deviceId:DEVICEID, 
                                                    device_model: DEVICE_MODEL, 
                                                    serialNumber: SERIALNUMBER, 
                                                    networkStatus: NETWORKSTATUS
                                                }
                                            }} >
                                            {t("PAYMENT_SUMMARY.CHANGE_PLAN_LINK")}
                                        </Link>
                                    )
                                }
                            </p>
                            <div className="plan-details">
                                <p className="current-due-price-txt">{t("PAYMENT_SUMMARY.DUE_TODAY_TXT")}</p>
                                <p className="current-due-price">
                                    {
                                        t("PAYMENT_SUMMARY.DUE_PRICE", {
                                            due_price: isHWInclusive_Signup
                                                ? formatNumberOnLocale(HWPlans?.discountedPrice, currencies[currency]?.code)
                                                : discountPlanIds
                                                    ? formatNumberOnLocale(DISCOUNT_PRICE, currencies[currency]?.code)
                                                    : formatNumberOnLocale(price, currencies[currency]?.code)
                                        })
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="bottom-section">
                        <ul>
                            {
                                (isBonusPagesFeatureEnabled && !isDeviceRefurbished) ? <li>{t("PAYMENT_SUMMARY.BOTTOM_SECTION_POINTS.POINT_1_FOR_BONUS_PAGES", {page_count: BONUS_PAGE_COUNT})} </li> : null
                            }
                            <li>
                            { discountPlanIds ? 
                                    (
                                        t("PAYMENT_SUMMARY.BOTTOM_SECTION_POINTS.FREE_TRAIL_POINT_1", {
                                            plan_price: formatNumberOnLocale(price, currencies[currency]?.code)
                                        })
                                    )
                                : (
                                        t("PAYMENT_SUMMARY.BOTTOM_SECTION_POINTS.NON_FREE_TRAIL_POINT_1", {
                                            plan_price: formatNumberOnLocale(price, currencies[currency]?.code)
                                        })
                                    )
                                }
                            </li>
                            <li>{t("PAYMENT_SUMMARY.BOTTOM_SECTION_POINTS.POINT_2")}</li>
                            {
                                (isHWInclusive_Signup && isRefurbished)
                                ? <li>{t("HARDWARE_SIGNUP.POINT_3_FOR_HWINCLUSIVE")}</li>
                                : <li>{t("PAYMENT_SUMMARY.BOTTOM_SECTION_POINTS.POINT_3")}</li>
                            }   
                        </ul>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default PaymentSummary;